module.exports = __webpack_public_path__ + "static/media/WOCO.dd355e9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/WOCO.jpg
// module id = 1784
// module chunks = 1